// extracted by mini-css-extract-plugin
export default {"container":"AddInsightButton_container__oH0a0","button":"AddInsightButton_button__JGDEA"};